import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-zhanghao",
  "use": "icon-icon-zhanghao-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 56 56\" id=\"icon-icon-zhanghao\">\n<path fill-rule=\"evenodd\" opacity=\"0\" fill=\"rgb(32, 57, 97)\" d=\"M-0.006,0.006 L55.994,0.006 L55.994,56.006 L-0.006,56.006 L-0.006,0.006 Z\" />\n<path fill-rule=\"evenodd\" fill=\"rgb(99, 133, 164)\" d=\"M30.482,30.014 C32.853,29.124 34.556,26.663 34.556,23.776 C34.556,20.129 31.843,17.180 28.504,17.180 C25.165,17.180 22.451,20.137 22.451,23.776 C22.451,26.663 24.154,29.115 26.525,30.014 C22.543,31.061 19.563,35.179 19.563,39.820 L37.436,39.820 C37.436,35.179 34.464,31.061 30.482,30.014 L30.482,30.014 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-zhanghao.svg
// module id = teEV
// module chunks = 97